import { makeStyles } from '@material-ui/core';
import React from 'react';
import { Pagination } from 'react-headless-pagination';
import styles from '../DialogList/styles';

const useStyles = makeStyles(styles);

interface DefaultQuery {
  offset: number;
  limit: number;
  search: string;
}

interface PaginateProps {
  count: number;
  page: number;
  query: DefaultQuery;
  handlePageChange: (page: number) => void;
}

const Paginate: React.FC<PaginateProps> = ({
  count,
  page,
  query,
  handlePageChange,
}) => {
  const classes = useStyles();
  const pages = Math.ceil(count / query.limit);

  return (
    <>
      <Pagination
        currentPage={page}
        setCurrentPage={handlePageChange}
        totalPages={pages}
        edgePageCount={3}
        middlePagesSiblingCount={2}
        className={classes.paginationContainer}
        truncableText="..."
        truncableClassName=""
      >
        <Pagination.PageButton
          activeClassName={classes.buttonActive}
          inactiveClassName=""
          className={classes.paginationContent}
        />
      </Pagination>
    </>
  );
};

export default Paginate;
